// Full-stats dialog showing per-offer breakdown for a blog post.
// Extracted from BlogsPage.js. Read-only.

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

const HEADER_CELL_SX = { fontWeight: 'bold', backgroundColor: '#f5f5f5' };

/**
 * @param {object} props
 * @param {object|null} props.stats - Blog stats object: { blogTitle, views, clicks, sales, revenue, offerStats[] }.
 *                                    The dialog is shown iff stats is non-null.
 * @param {() => void} props.onClose
 */
const ExpandedStatsDialog = ({ stats, onClose }) => (
  <Dialog
    open={stats !== null}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
  >
    <DialogTitle>
      Full Stats: {stats?.blogTitle || 'Blog Stats'}
    </DialogTitle>
    <DialogContent>
      <Table size="small" sx={{ width: '100%', tableLayout: 'auto', mt: 1 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={HEADER_CELL_SX}>Offer</TableCell>
            <TableCell sx={HEADER_CELL_SX} align="right">Views</TableCell>
            <TableCell sx={HEADER_CELL_SX} align="right">Clicks</TableCell>
            <TableCell sx={HEADER_CELL_SX} align="right">CTR</TableCell>
            <TableCell sx={HEADER_CELL_SX} align="right">Sales</TableCell>
            <TableCell sx={HEADER_CELL_SX} align="right">CVR</TableCell>
            <TableCell sx={HEADER_CELL_SX} align="right">Revenue</TableCell>
            <TableCell sx={HEADER_CELL_SX} align="right">RPV</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Overall Blog Stats Row */}
          <TableRow>
            <TableCell sx={{ fontWeight: 'medium' }}>content</TableCell>
            <TableCell align="right">{stats?.views?.toLocaleString() || '0'}</TableCell>
            <TableCell align="right">{stats?.clicks?.toLocaleString() || '-'}</TableCell>
            <TableCell align="right">-</TableCell>
            <TableCell align="right">{stats?.sales?.toLocaleString() || '-'}</TableCell>
            <TableCell align="right">-</TableCell>
            <TableCell align="right">{stats?.revenue ? `$${stats.revenue.toFixed(2)}` : '-'}</TableCell>
            <TableCell align="right">-</TableCell>
          </TableRow>
          {/* Offer-level stats rows */}
          {stats?.offerStats?.map((offer, offerIndex) => (
            <TableRow key={offerIndex}>
              <TableCell sx={{ fontWeight: 'medium' }}>{offer.offerName}</TableCell>
              <TableCell align="right">{offer.views.toLocaleString()}</TableCell>
              <TableCell align="right">{offer.clicks.toLocaleString()}</TableCell>
              <TableCell align="right">{offer.ctr}%</TableCell>
              <TableCell align="right">{offer.sales.toLocaleString()}</TableCell>
              <TableCell align="right">{offer.cvr}%</TableCell>
              <TableCell align="right">${offer.revenue.toFixed(2)}</TableCell>
              <TableCell align="right">${offer.rpv}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default ExpandedStatsDialog;
